module.exports = __webpack_public_path__ + "img/Voyage.cdc0c251.svg";